module.exports = __webpack_public_path__ + "components/rewards/stanford-skiing/static/logo-be6e4c1a0fc5c5083e4ee47a15bc600e.webp";